import { Color } from "@repo/app-types/constants/colors";
import type { Size } from "@repo/ui/helpers/helpers";
import { Pill, pillStyle } from "@repo/ui/Pills/pill";
import type { FC } from "react";
import { SizedContainer } from "../../components/sizedContainer.js";
import { computePassRatePillColor } from "../teammatePerformance/gradingPassRatePill.js";

export interface TrainingAssessmentTemplateScorePillProps {
  size: Size;
  /** The score as a number from 0-1, null if not applicable, or undefined if not available. */
  score: number | null | undefined;
  isLoading?: boolean;
  onClick?: () => void;
}

const scoreStyle = "text-center tabular-nums";
const scoreForSize = "100%";

export const TrainingAssessmentTemplateScorePill: FC<
  TrainingAssessmentTemplateScorePillProps
> = (props) => {
  const { score } = props;

  if (score === undefined && props.isLoading) {
    // TODO: Figure out how to better use PillSkeleton and SizedContainer together.
    return (
      <div
        className={pillStyle({
          size: props.size,
          className: "animate-pulse bg-gray-300 ring-0",
        })}
      >
        <SizedContainer className={scoreStyle} childrenForSize={scoreForSize} />
      </div>
    );
  }

  if (score === undefined) {
    return (
      <Pill
        color={Color.Gray}
        size={props.size}
        label={
          <SizedContainer className={scoreStyle} childrenForSize={scoreForSize}>
            --
          </SizedContainer>
        }
        onClick={props.onClick}
      />
    );
  }

  if (score === null) {
    return (
      <Pill
        color={Color.Gray}
        size={props.size}
        label={
          <SizedContainer className={scoreStyle} childrenForSize={scoreForSize}>
            n/a
          </SizedContainer>
        }
        onClick={props.onClick}
      />
    );
  }

  return (
    <Pill
      // Use the same color scheme as the pass rate.
      color={computePassRatePillColor(score)}
      size={props.size}
      label={
        <SizedContainer className={scoreStyle} childrenForSize={scoreForSize}>
          {(score * 100).toFixed(0)}%
        </SizedContainer>
      }
      onClick={props.onClick}
    />
  );
};
